import { render } from "./CustomerBatchForm.vue?vue&type=template&id=4df7badf&scoped=true"
import script from "./CustomerBatchForm.vue?vue&type=script&lang=js"
export * from "./CustomerBatchForm.vue?vue&type=script&lang=js"

import "./CustomerBatchForm.vue?vue&type=style&index=0&id=4df7badf&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4df7badf"]])

export default __exports__